module.exports = __webpack_public_path__ + "img/pic_ball.0200f7de.png";